export enum ErrorCode {
  $301 = -301,
  $302 = -302,
  $303 = -303,
  $304 = -304,
  $305 = -305,
  $306 = -306,
  $307 = -307,
  $308 = -308,
  $309 = -309,
  $310 = -310,
}

export enum ErrorCodeMessageType {
  ERROR_USERALREADYEXIST,
  ERROR_USERNOTFOUND,
  ERROR_INVALIDTOKEN,
  ERROR_OBJECTALREADYEXISTS,
  ERROR_ADDRESSISNOTCONFIRMED,
  ERROR_INVALIDPARAMETERS,
  ERROR_USERNOTAUTHORIZED,
  ERROR_USEREMAILNOTVERFIED,
  ERROR_UNAUTHORIZED,
  ERROR_VALIDATION,
  SERVER_ERROR
}

export enum SuccessCode {
  $1 = 1,
  $2 = 2,
  $3 = 3,
  $4 = 4,
  $5 = 5
}

export enum SuccessCodeMessageType {
  SUCCESSFUL_CREATED,
  SUCCESSFUL_UPDATED,
  SUCCESSFUL_ADDED,
  SUCCESSFUL_ACTION,
  SUCCESSFUL_REMOVED,
  DEFAULT
}

export function getErrorCodeMessageType(errorCode: number) {
  switch (errorCode) {
    case ErrorCode.$301:
      return ErrorCodeMessageType.ERROR_USERALREADYEXIST
    case ErrorCode.$302:
      return ErrorCodeMessageType.ERROR_USERNOTFOUND
    case ErrorCode.$303:
      return ErrorCodeMessageType.ERROR_INVALIDTOKEN
    case ErrorCode.$304:
      return ErrorCodeMessageType.ERROR_OBJECTALREADYEXISTS
    case ErrorCode.$305:
      return ErrorCodeMessageType.ERROR_ADDRESSISNOTCONFIRMED
    case ErrorCode.$306:
      return ErrorCodeMessageType.ERROR_INVALIDPARAMETERS
    case ErrorCode.$307:
      return ErrorCodeMessageType.ERROR_USERNOTAUTHORIZED
    case ErrorCode.$308:
      return ErrorCodeMessageType.ERROR_USEREMAILNOTVERFIED
    case ErrorCode.$309:
      return ErrorCodeMessageType.ERROR_UNAUTHORIZED
    case ErrorCode.$310:
      return ErrorCodeMessageType.ERROR_VALIDATION

    default:
      return ErrorCodeMessageType.SERVER_ERROR
  }
}

export function getSuccessCodeMessageType(successCode: number) {
  switch (successCode) {
    case SuccessCode.$1:
      return SuccessCodeMessageType.SUCCESSFUL_CREATED
    case SuccessCode.$2:
      return SuccessCodeMessageType.SUCCESSFUL_UPDATED
    case SuccessCode.$3:
      return SuccessCodeMessageType.SUCCESSFUL_ADDED
    case SuccessCode.$4:
      return SuccessCodeMessageType.SUCCESSFUL_ACTION
    case SuccessCode.$5:
      return SuccessCodeMessageType.SUCCESSFUL_REMOVED

    default:
      return SuccessCodeMessageType.DEFAULT
  }
}